const config = {
  GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  WEB_APP_URL: process.env.REACT_APP_WEB_APP_URL,
  API_URL: process.env.REACT_APP_API_URL,
  OPINOMETRO_URL: process.env.REACT_APP_OPINOMETRO_URL,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SENTRY_REPLAY_SESSION_SAMPLE_RATE: process.env.REACT_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE: process.env.REACT_APP_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE
}

export default config
